var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolestielleNameCurvedNavajoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470.85mm",
    height: "1093.6mm",
    viewBox: "0 0 470.85 1093.6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -573.75,
    y: -369.21,
    width: 521.97,
    height: 1193.6,
    rx: 248.56,
    ry: 55.936,
    style: {
      fillRule: "evenodd",
      fill: "#00f",
      strokeWidth: 0.26458
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.63 369.21)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-176.74 -39.563)",
    x: 209.86963,
    y: 154.02876,
    style: {
      fill: "#fddfaf",
      fontFamily: "'Bodoni 72 Oldstyle'",
      fontSize: "12.491px",
      paintOrder: "markers fill stroke",
      strokeWidth: 59.81
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#fddfaf",
      strokeWidth: 59.81
    }
  }, "                                                                                                                                                                        Solestielle")), /*#__PURE__*/React.createElement("text", {
    x: -126.85035,
    y: 178.56819,
    style: {
      fill: "none",
      fontFamily: "'Bodoni 72 Oldstyle'",
      fontSize: "12.491px",
      paintOrder: "markers fill stroke",
      stroke: "#ffe0ad"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -126.85035,
    y: 178.56819
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#fddfaf",
      fontFamily: "'Bodoni 72 Oldstyle'",
      fontSize: "12.491px",
      paintOrder: "markers fill stroke"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#path10"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#fddfaf",
      fontFamily: "'Bodoni 72 Oldstyle'",
      fontSize: "282.22px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "                 Solestielle"))), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m608.69 148.5a484.76 426.43 0 0 1-484.76 426.43 484.76 426.43 0 0 1-484.76-426.43 484.76 426.43 0 0 1 484.76-426.43 484.76 426.43 0 0 1 484.76 426.43z",
    clipPath: "url(#clipPath11)",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeWidth: 25,
      stroke: "#ffe0ad"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolestielleNameCurvedNavajoWhite);
export default __webpack_public_path__ + "static/media/solestielle_name_curved_navajo_white.ebfe9c62126df2b2902f8a45ee97640c.svg";
export { ForwardRef as ReactComponent };